// extracted by css-extract-rspack-plugin
export default {"description":"FkTargetPicker-module__description___BxCLr"};